export { LicensesTable } from './LicensesTable'
